<template>
  <div class="showVideo">
    <div ref="showVideo">
      <div class="video_box"
        :style="!((index === count && !slider) || index + 1 === slider) ? 'height: 0': ''"
        :class="[!item.isControl ?'isImg':'',
        hasVideoButton.length > 0 ? 'hasButton_box': '',
        hasVideoSlider ? 'hasSlider_box':'']"
        v-for="(item, index) in videoArr" :key="item.url">
        <video
          @dragleave.prevent
          @dragover.prevent
          @dragleave="dragLeave"
          @dragover="dragEnter"
          v-if="(index === count && !slider) || index + 1 === slider"
          :src="item.url || item.video"
          :loop="item.isloop"
          :controls="item.isControl"
          :autoPlay="item.autoPlay"
          :ref="onlyId"
          :data-video-no="item.videoNo"
          controlslist="nodownload noplaybackrate noremoteplayback"
          disablePictureInPicture
        ></video>
        <img class="big_video" v-if="(item.isImg || item.isControl || item.canZoom) && !item.isBig && ((index === count && !slider) || index + 1 === slider)" @click="changeVideo(index, 'big', item)"
          :src="require('@/assets/exam/button_fangda.png')" alt="">
        <img class="big_video" v-if="(item.isImg || item.isControl || item.canZoom) && item.isBig && ((index === count && !slider) || index + 1 === slider)" @click="changeVideo(index, '', item)"
          :src="require('@/assets/exam/icon_suoxiao.png')" alt="">
        <div class="playButton" v-if="showPlay && index === count">
          <img
            src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624ff999e0aeb/532032200.png"
            alt=""
            class="play"
            @click="play(index)"
          />
        </div>
        <div v-if="item.isBack" class="rest_button" data-click-stats="click_video_back#点击返回按钮" @click="videoBack">
          返回
        </div>
      </div>
      <div class="video_button" v-if="this.hasVideoButton.length > 0">
        <div class="button" :class="{ button_disabled: item.disabled }"
          :style="{color: idex === count ? '#106172':'#000', width:  (100 / hasVideoButton.length) + '%'}"
          v-for="(item, idex) in hasVideoButton" :key="idex"
          :data-click-stats="item.disabled ? undefined : `click_video_switch_button_${idex + 1}#点击${item.text || item.title}按钮`"
        >
          <span v-if="item.text" @click="item.disabled || handlerChange(idex)">{{item.text}}</span>
          <div v-if="item.img"
            :style="{border: idex === count ? '1px solid #106172':'none'}"
            @click="item.disabled || handlerChange(idex)">
            <img width="25" :src="item.img" alt="">
            <span :style="{color: idex === count ? '#106172':'#000'}">{{item.title}}</span>
          </div>
          <div class="line" v-if="idex !== hasVideoButton.length - 1 && item.text" />
        </div>
      </div>
    </div>
    <el-slider
      v-if="hasVideoSlider"
      v-model="slider"
      :marks="marks"
      :max="3"
      :show-tooltip="false">
    </el-slider>
  </div>
</template>

<script>
import { postProcessStats } from '@/utils/stats'

export default {
  props: {
    videoArr: {
      type: Array,
      default: () => []
    },
    onlyId: {
      type: String,
      default: ''
    },
    hasVideoButton: {
      type: Array,
      default: () => []
    },
    hasVideoSlider: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPlay: true,
      video: {},
      count: 0,
      slider: null,
      isBig: false,
      marks: { 1: '小雨', 2: '中雨', 3: '大雨' }
    }
  },
  mounted() {
    this.initVideo()
  },
  methods: {
    changeVideo(index, type, videoData) {
      this.isBig = type === 'big'
      const dom = this.$refs.showVideo
      if (type === 'big') {
        dom.classList.add('fullScreen')
      } else {
        dom.classList.remove('fullScreen')
      }
      this.videoArr.forEach((item, idex) => {
        if (index === idex) {
          item.isBig = type === 'big'
        }
      })
      this.$forceUpdate()
      const num = videoData.videoNo ? videoData.videoNo : ''
      const numSuffix = videoData.videoNo ? '_' + num : ''
      if (videoData.canZoom) {
        postProcessStats({
          event: (type == 'big' ? 'click_zoom_in_button' : 'click_zoom_out_button') + numSuffix,
          note: type == 'big' ? `点击图片${num}放大按钮` : `点击图片${num}缩小按钮`,
        })
      } else {
        postProcessStats({
          event: (type == 'big' ? 'video_zoom_in' : 'video_zoom_out') + numSuffix,
          note: type == 'big' ? `视频${num}放大` : `视频${num}缩小`,
        })
      }
    },
    initVideo() {
      if (!this.$refs[this.onlyId]) return
      this.video = this.$refs[this.onlyId];
      // console.log(this.video, Array.isArray(this.video))
      if (Array.isArray(this.video)) {
        const onlyOne = this.video.length == 1
        this.video.forEach((/** @type HTMLVideoElement */item, index) => {
          let num = onlyOne ? '' : index + 1
          let numSuffix = onlyOne ? '' : '_' + num
          // 若有明确的视频编号，则使用
          if (item.dataset.videoNo) {
            num = item.dataset.videoNo
            numSuffix = '_' + num
          }
          // 只对可控制的视频进行统计
          const statsVideoPlay = item.controls
          const sendProcessStats = data => statsVideoPlay && postProcessStats(data)
          item.addEventListener('pause', () => {
            if (this.hasVideoButton.length === 0 && !this.hasVideoSlider && !this.videoArr[0].isBack) {
              this.showPlay = true
            }
            sendProcessStats({
              event: 'video_pause' + numSuffix,
              note: '暂停视频' + num,
            })
          });
          item.addEventListener('play', () => {
            this.showPlay = false
            sendProcessStats({
              event: 'video_play' + numSuffix,
              note: '播放视频' + num,
            })
          });
          item.addEventListener('seeking', () => {
            if (!item.isSeeking) {
              item.isSeeking = true
              item.oldCurrentTime = item.currentTime
            }
          })
          item.addEventListener('seeked', () => {
            item.isSeeking = false
            const oldCurrentTime = item.oldCurrentTime || 0
            if (item.currentTime - oldCurrentTime > 3) {
              sendProcessStats({
                event: 'video_drag_to_right' + numSuffix,
                note: `拖拽视频${num}进度条-向右`,
              })
            } else if (item.currentTime - oldCurrentTime < 3) {
              sendProcessStats({
                event: 'video_drag_to_left' + numSuffix,
                note: `拖拽视频${num}进度条-向左`,
              })
            }
            item.oldCurrentTime = item.currentTime
          })
          item.addEventListener('ended', () => {
            console.log(3)
            this.$parent.videoEnd(this.onlyId)
          }, false);
        })
      } else {
        // 只对可控制的视频进行统计
        const statsVideoPlay = this.video.controls
        const sendProcessStats = data => statsVideoPlay && postProcessStats(data)
        this.video.addEventListener('pause', () => {
          if (this.hasVideoButton.length === 0 && !this.hasVideoSlider && !this.videoArr[0].isBack) {
            this.showPlay = true
          }
          sendProcessStats({
            event: 'video_pause',
            note: '暂停视频',
          })
        });
        this.video.addEventListener('play', () => {
          this.showPlay = false
          sendProcessStats({
            event: 'video_play',
            note: '播放视频',
          })
        });
        this.video.addEventListener('ended', () => {
          console.log(3)
          this.$parent.videoEnd()
        }, false);
        this.video.addEventListener('seeking', () => {
          if (!this.video.isSeeking) {
            this.video.isSeeking = true
            this.video.oldCurrentTime = this.video.currentTime
          }
        })
        this.video.addEventListener('seeked', () => {
          this.video.seeking = false
          const oldCurrentTime = this.video.oldCurrentTime || 0
          if (this.video.currentTime - oldCurrentTime > 3) {
            sendProcessStats({
              event: 'video_drag_to_right',
              note: '拖拽视频进度条-向右',
            })
          } else if (this.currentTime - oldCurrentTime < 3) {
            sendProcessStats({
              event: 'video_drag_to_left',
              note: '拖拽视频进度条-向左',
            })
          }
          this.video.oldCurrentTime = this.video.currentTime
        })
      }
    },
    videoBack() {
      if (!this.$refs[this.onlyId]) return
      this.video = this.$refs[this.onlyId];
      if (Array.isArray(this.video)) {
        this.video.forEach(item => {
          item.currentTime = 0
          item.play()
        })
      } else {
        this.video.currentTime = 0
        this.video.play()
      }
    },
    play() {
      if (Array.isArray(this.video)) {
        this.video.forEach(item => {
          item.play()
        })
      } else {
        this.video.play()
      }
    },
    handlerChange(num) {
      this.count = num
      this.videoArr.forEach((item, idex) => {
        if (num === idex) {
          item.isBig = this.isBig
        } else {
          item.isBig = false
        }
      })
    },
    dragEnd(index) {
      if (this.enter) {
        this.count = index
        this.videoArr.forEach((item, idex) => {
          if (index === idex) {
            item.isBig = this.isBig
          } else {
            item.isBig = false
          }
        })
      }
    },
    dragEnter() {
      this.enter = true
    },
    dragLeave() {
      this.enter = false
    }
  },
  watch: {
    onlyId: {
      handler() {
        this.initVideo()
      },
      immediate: false
    },
    videoArr: {
      handler() {
        this.count = 0
      },
      immediate: false,
      deep: true
    }
  },
}
</script>
<style lang="less" scoped>
.showVideo {
  padding: 0 27px;
  margin-top: 12px;
  min-height: 380px;
  max-height: 500px;
  .video_box{
    // width: 100%;
    // height: 100%;
    text-align: center;
    position: relative;
    video {
      width: 80%;
      height: 300px;
      object-fit: fill;
    }
    video::-webkit-media-controls-fullscreen-button {
      display: none;
    }
    .big_video{
      width: 80px;
      position: absolute;
      right: 12%;
      bottom: 12%;
      cursor: pointer;
    }
    .playButton {
      width: 100%;
      height: 300px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      // bottom: 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.25);
      .play{
        width: 50px;
        cursor: pointer;
      }
    }
    .rest_button{
      width: 60px;
      height: 60px;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 60px;
      background-color: #667c6b;
      font-size: 20px;
      font-weight: blod;
      position: absolute;
      bottom: 10px;
      right: 10px;
      cursor: pointer;
    }
  }
  .video_button{
    width: 100%;
    height: 60px;
    background-color: #EDEDED;
    border-radius: 35px;
    margin-top: 10px;
    display: flex;
    .button{
      // width: 25%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      cursor: pointer;
      position: relative;
      span{
        font-size: 20px;
        font-weight: bold;
        display: inline-block;
        width: calc(100% - 2px);
        text-align: center;
      }
      div{
        height: 100%;
        padding: 5px 10px;
        display: flex;
        align-items: center;
        border-radius: 10px;
        >img{
          margin-right: 5px;
        }
      }
      .line{
        width: 2px;
        height: 20px;
        padding: 0;
        background-color: #D8D8D8;
        // margin-left: 10px;
        // display: inline-block;
        border-radius: 2px;
        position: relative;
        right: 0;
      }
    }
    .button_disabled {
      cursor: default;
    }
  }
  .isImg.video_box{
    video{
      border: 1px solid #ccc;
    }
    video::-webkit-media-controls-enclosure{
        display: none;
    }
  }
  .isImg.video_box,
  .hasButton_box.video_box{
    video::-webkit-media-controls-play-button,
    video::-webkit-media-controls-timeline ,
    video::-webkit-media-controls-current-time-display,
    video::-webkit-media-controls-time-remaining-display,
    video::-webkit-media-controls-mute-button,
    video::-webkit-media-controls-toggle-closed-captions-button,
    video::-webkit-media-controls-volume-slider {
      display: none;
    }
  }
  .hasButton_box.video_box{
    height: auto;
    video{
      height: 300px;
    }
    .big_video{
      width: 70px;
      position: absolute;
      right: 12%;
      bottom: 4%;
      cursor: pointer;
    }
    // video::-webkit-media-controls-play-button,
    // video::-webkit-media-controls-timeline ,
    // video::-webkit-media-controls-current-time-display,
    // video::-webkit-media-controls-time-remaining-display,
    // video::-webkit-media-controls-mute-button,
    // video::-webkit-media-controls-toggle-closed-captions-button,
    // video::-webkit-media-controls-volume-slider {
    //   display: none;
    // }
  }
  .hasSlider_box.video_box{
    height: auto;
    video{
      height: 340px;
    }
    .big_video{
      width: 80px;
      position: absolute;
      right: 12%;
      bottom: 25%;
      cursor: pointer;
    }
    .playButton {
      width: 100%;
      height: 340px;
    }
  }
  /deep/.el-slider__button-wrapper{
    top: -0.25rem;
  }
  /deep/.el-slider__marks-text{
    width: 30px;
  }
}
.fullScreen{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10;
  .video_box,
  .hasButton_box.video_box{
    width: 100%;
    height: 100%;
    video{
      width: 80%;
      height: 80%;
      margin-top: 10vh;
    }
  }
  .hasButton_box.video_box video{
    width: 70%;
    height: 75%;
    margin-top: 8vh;
  }
  .hasButton_box.video_box .big_video{
    width: 100px;
    right: 16%;
    bottom: 20%;
  }
  .video_button{
    position: absolute;
    top: 83%;
    width: 80%;
    left: 9%;
    height: 80px;
    font-size: 22px;
  }
}
</style>
